import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/inbox-view'),
    redirect: to => ({
      name: 'conversations',
      params: { accountId: to.params.accountId },
    }),
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    children: [
      {
        path: '',
        name: 'inbox_view',
        redirect: to => ({
          name: 'conversations',
          params: { accountId: to.params.accountId },
        }),
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
        },
      },
      {
        path: ':type/:id',
        name: 'inbox_view_conversation',
        redirect: to => ({
          name: 'conversations',
          params: { accountId: to.params.accountId },
        }),
        meta: {
          permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
        },
      },
    ],
  },
];
